const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'absence',
        preventClearOnCancel: true,
    },

    methods: {

        /**
         * this function will be called after the form values has been changed.
         *
         * @param isRelationChange 		boolean - was the change related to a relation or not
         * @param changeDone 			boolean - has a change been done
         * @param fieldData 			{} - fieldData used to define what to do
         */
        onChange: function(isRelationChange, changeDone, fieldData){
            this.updateView(fieldData || {})
        },

        updateView(fieldData, isInit = false){
            if(!this.config.isReady) return;
            fieldData = fieldData || {}
            const absenceType = this.getFieldValue('type')
            const lastAbsenceType = `${this.model.lastAbsenceType}`
            let refreshTimeRangeField = true

            // employee vs contractor
            let $resetAutoComplete
            if(fieldData.fieldCode === 'contractorID' && fieldData.fieldValue){
                $resetAutoComplete = this.$.find('[data-field-code="employeeID"]')
            } else if(fieldData.fieldCode === 'employeeID' && fieldData.fieldValue){
                $resetAutoComplete = this.$.find('[data-field-code="contractorID"]')
            }

            if(($resetAutoComplete || {}).length > 0){
                const resetAutoComplete = getComponent($resetAutoComplete)
                if(resetAutoComplete){
                    resetAutoComplete.unChoose()
                }
            }

            if(isInit){
                const storage = this.getStorage()
                const employeeType = ((((storage.user || {}).data || {}).userTableAssociates || {}).employee || {}).type
                if(employeeType){
                    const $typeField = this.$.find('.fieldOf_type')
                    const $typeToggle = $typeField.find('[data-field-type="toggle"]')
                    if($typeToggle.length > 0){
                        const typeToggle = getComponent($typeToggle)
                        if(typeToggle){
                            if(employeeType === 'internal'){
                                $typeField.show()
                                typeToggle.setDisabledValues({
                                    notAvailable: true,
                                })
                            } else if(employeeType === 'external') {
                                $typeField.hide()
                                typeToggle.select('notAvailable')
                                refreshTimeRangeField = absenceType === 'notAvailable'
                            } else {
                                $typeField.show()
                                typeToggle.setDisabledValues()
                            }
                        }
                    }
                }
            }

            // correct timeRange if necessary
            if(isInit || fieldData.fieldCode === 'type'){
                this.model.lastAbsenceType = absenceType
                const $timeRange = this.$.find('.fieldOf_timeRange > .base_form_fields_period-air')
                if(($timeRange || {}).length > 0){
                    const timeRange = getComponent($timeRange)
                    if(timeRange){
                        // update timeRange if necessary
                        if(!isInit){
                            let from, to
                            if(lastAbsenceType === 'restWish' && absenceType !== 'restWish') {
                                if(timeRange.model.dateFrom)    from = utils.moment(timeRange.model.dateFrom).startOf('day').toISOString();
                                if(timeRange.model.dateTo)      to = utils.moment(timeRange.model.dateTo).startOf('day').toISOString();
                            }
                            if(from || to){
                                timeRange.onChange(from, to)
                            }
                        }

                        // update config
                        const configByAbsenceType = timeRange.model.config.configByAbsenceType || {}
                        timeRange.updateFieldConfig(utils.simpleMerge(
                            configByAbsenceType.base || {},
                            configByAbsenceType[absenceType] || configByAbsenceType.default || {},
                        ), refreshTimeRangeField)
                    }
                }
            }

            // correct confirmation if necessary
            const $confirmedField = this.$.find('.fieldOf_confirmed')
            const confirmedToggle = getComponent($confirmedField.find('> .base_form_fields_toggle'), true)
            if($confirmedField.length > 0 && confirmedToggle){
                if(absenceType === 'notAvailable'){
                    $confirmedField.hide()
                    confirmedToggle.select(0)
                } else if(lastAbsenceType === 'notAvailable') {
                    $confirmedField.show()
                    confirmedToggle.select(0)
                }
            }
        }
    },

    hooks: {
        _postAttach($element, options){
            this.updateView(undefined, true)
        }
    }
}